import { useState } from 'react';

export default function CustomerReviews() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const reviews = [
    {
      text: "Best prices in Mississauga. Honest and reliable service.",
      name: "Michael Thompson",
      role: "Verified Customer"
    },
    {
      text: "They replaced my brakes and saved me hundreds compared to dealerships.",
      name: "Sarah Johnson",
      role: "Verified Customer"
    },
    {
      text: "Very knowledgeable and professional. Highly recommended!",
      name: "David Chen",
      role: "Verified Customer"
    },
    {
      text: "Great selection of parts and the staff really knows their stuff.",
      name: "Jennifer Martinez",
      role: "Verified Customer"
    },
    {
      text: "Fast service and fair pricing. Been coming here for years.",
      name: "Robert Williams",
      role: "Verified Customer"
    },
    {
      text: "Quality parts at discount prices. Exactly what they promise.",
      name: "Lisa Anderson",
      role: "Verified Customer"
    }
  ];

  const visibleReviews = reviews.slice(currentIndex, currentIndex + 3);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? reviews.length - 3 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev >= reviews.length - 3 ? 0 : prev + 1));
  };

  return (
    <section id="reviews" className="py-20 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16 relative">
          <div className="absolute left-1/2 top-0 -translate-x-1/2 -translate-y-4 text-red-600 text-8xl opacity-20 font-serif">"</div>
          <h2 className="font-rajdhani font-bold text-4xl md:text-5xl text-black mb-4 relative">
            What Our Customers Say
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-12">
          {visibleReviews.map((review, index) => (
            <div
              key={currentIndex + index}
              className="bg-white rounded-xl p-8 shadow-md hover:shadow-xl transition-all duration-300"
            >
              <div className="flex gap-1 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-yellow-500 text-xl"></i>
                ))}
              </div>
              <p className="text-gray-700 text-lg mb-6 leading-relaxed font-serif italic">
                "{review.text}"
              </p>
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gray-200 rounded-full flex-shrink-0">
                  <i className="ri-user-line text-gray-600 text-xl"></i>
                </div>
                <div>
                  <div className="font-bold text-black">{review.name}</div>
                  <div className="text-sm text-gray-500">{review.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between">
          <p className="text-gray-600 italic">
            Join hundreds of satisfied customers across the GTA.
          </p>
          <div className="flex gap-3">
            <button
              onClick={handlePrev}
              className="w-12 h-12 flex items-center justify-center bg-gray-200 hover:bg-gray-300 rounded-lg transition-colors cursor-pointer"
              aria-label="Previous reviews"
            >
              <i className="ri-arrow-left-line text-gray-700 text-xl"></i>
            </button>
            <button
              onClick={handleNext}
              className="w-12 h-12 flex items-center justify-center bg-black hover:bg-gray-800 rounded-lg transition-colors cursor-pointer"
              aria-label="Next reviews"
            >
              <i className="ri-arrow-right-line text-white text-xl"></i>
            </button>
          </div>
        </div>
      </div>
    </section>
  );
}
